import { useAuthenticationContext } from '@/app/AuthenticationContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { getSessionTokens } from '@/services/auth/authentication';
import { E2nApi } from '@e2n/e2n-api';

// Must be rendered below AuthorizedPage since useStandortContext needs StandortContextProvider.
export function E2nApiRoute() {
  const { userInfo } = useAuthenticationContext();
  const { currentStandort } = useStandortContext();

  return (
    <E2nApi
      getAccessToken={async () =>
        (await getSessionTokens())?.accessToken.toString()
      }
      user={
        userInfo && {
          id: userInfo.id,
          username: userInfo.username,
        }
      }
      standort={{ id: currentStandort.id, name: currentStandort.name }}
    />
  );
}
